import { action } from 'typesafe-actions';
import ActionTypes from './constants';
import { Background } from 'constants/Background';

export const setFooterBackground = (background: Background) =>
  action(ActionTypes.SET_FOOTER_BACKGROUND, background);